import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

class InfoTileNoTranslation extends Component {
  static propTypes = {};

  render() {
    const { t } = this.props;
    const keys = {
      'title': this.props.title,
      'description': this.props.description,
    }
    const styles = {
      backgroundColor: this.props.backgroundColor,
      color: this.props.color ? this.props.color : 'black'
    };
    return (
      <div style={styles} className="common-info-tile">
        <div className="info">
          <h4 className="tile-info">
            <b className="tile-title">{t(keys.title, { framework: 'React' })}</b>
          </h4>
          {<p className="tile-info">{t(keys.description, { framework: 'React' })}</p>}
        </div>
      </div>
    );
  }
}
const InfoTile = withTranslation('common')(InfoTileNoTranslation)

export default InfoTile;


// WEBPACK FOOTER //
// ./src/features/common/InfoTile.js